import { Box, Button, Chip, Typography } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { useTranslation } from 'react-i18next';
import { useAtomValue } from 'jotai';
import { Business_Profile_Enum, User_Role_Enum } from '@kheops/graphql';
import { currentContextAtom } from '../../state';
import { IntercomArticlesIds } from '../../common/utils/intercom.articles.enum';
import { BUYER_ROLES, SUPPLIER_ROLES } from './CompanyTeamPage';
import { useCompanyTeamRoleWording } from './useCompanyTeamRoleWording';

export interface UserRoleSelectProps {
  onChange: (role: User_Role_Enum) => void;
  value?: User_Role_Enum;
}

export default function UserRoleSelect({ onChange, value }: UserRoleSelectProps): React.JSX.Element {
  const { t } = useTranslation(['common']);
  const { realm, companyBrand } = useAtomValue(currentContextAtom);
  const availableRoles = realm === Business_Profile_Enum.Buyer ? BUYER_ROLES : SUPPLIER_ROLES;
  const resolvedWording = useCompanyTeamRoleWording(companyBrand || undefined);

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: 1,
      }}
    >
      <Box sx={{ display: 'flex', flexDirection: 'column' }}>
        <Typography variant="titleSmall">
          {t('company:role')}
        </Typography>
        <Typography variant="bodySmall" color="onSurfaceVariant">
          {t('company:role_description')}
        </Typography>
      </Box>
      <Box
        sx={{
          display: 'flex',
          flexWrap: 'wrap',
          gap: 1,
        }}
      >
        {availableRoles.map((buyerRole) => (
          <Chip
            key={buyerRole}
            variant="filter"
            label={t(resolvedWording[buyerRole])}
            onClick={() => onChange(buyerRole)}
            className={value === buyerRole ? 'Kheops-selected' : ''}
          />
        ))}
      </Box>
      <Button
        startIcon={<InfoOutlinedIcon />}
        onClick={() => window.Intercom('showArticle', realm === Business_Profile_Enum.Buyer ? IntercomArticlesIds.BuyerRolesAndPermissions : IntercomArticlesIds.SupplierRolesAndPermissions)}
        sx={{ width: 'fit-content' }}
      >
        {t('common:learn_more_about')}
      </Button>
    </Box>
  );
}
